
// components
import GridPageAbstract from '../../abstract/GridPageAbstract';
import { mergeHeadWithStorage } from '../../../utils/gridHeadStorage';

export default class CryptoTokensPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'crypto-tokens';
        this.Server = this.props.context.getState().server.cryptoTokens;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['name', 'contractAddress'];
        this.showDatePicker = false;

        const defaultHead = [
            {
                id: 'name',
                label: 'name',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'chainId',
                label: 'chain',
                alignRight: false,
                cell: 'Select',
                displayGrid: true,
                from: 'chains',
                object: 'chain',
                show: 'name'
            },
            {
                id: 'contractAddress',
                label: 'contractAddress',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'isNative',
                label: 'isNative',
                alignRight: false,
                cell: 'Checkbox',
                displayGrid: true
            },
            {
                id: 'decimals',
                label: 'decimals',
                alignRight: true,
                cell: 'Number',
                displayGrid: true
            }
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);

        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}

